import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  isScheduleInfoLoading: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CLEAR_SCHEDULE_INFO:
    case actionTypes.FETCH_SCHEDULE_INFO_SUCCESS:
    case actionTypes.FETCH_SCHEDULE_INFO_ERROR:
      return action.payload;
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.FETCH_SCHEDULE_INFO:
          return Object.assign({}, state, { isScheduleInfoLoading: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.FETCH_SCHEDULE_INFO:
          return Object.assign({}, state, { isScheduleInfoLoading: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
